import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { onError } from '@apollo/client/link/error';
import { AuthService } from '@app/@core-auth/services';
import { GRAPHQL_CONFIG, GraphQLConfig } from './graphql.config';
import { GRAPHQL_ERROR_HANDLERS, BaseErrorHandler } from './error-handlers';

@NgModule()
export class GraphQLModule {
  static forRoot(): ModuleWithProviders<GraphQLModule> {
    return {
      ngModule: GraphQLModule,
      providers: [
        Apollo,
        {
          provide: APOLLO_OPTIONS,
          useFactory: (
            httpLink: HttpLink,
            auth: AuthService,
            config: GraphQLConfig,
            errorHandlers: BaseErrorHandler[]
          ) => {
            const http = httpLink.create({ uri: config.url });

            const authLink = new ApolloLink((operation, forward) => {
              operation.setContext({
                headers: auth.getAuthorizationHeader(),
              });
              return forward(operation);
            });

            const errorLink = onError((error) => {
              errorHandlers.forEach((h) => h.handleError(error));
            });

            return {
              link: ApolloLink.from([errorLink, authLink, http]),
              cache: new InMemoryCache(),
              defaultOptions: {
                watchQuery: {
                  fetchPolicy: 'no-cache',
                  errorPolicy: 'all',
                },
                query: {
                  fetchPolicy: 'no-cache',
                  errorPolicy: 'all',
                },
              },
            };
          },
          deps: [HttpLink, AuthService, GRAPHQL_CONFIG, GRAPHQL_ERROR_HANDLERS],
        },
      ],
    };
  }
}
